import { createReactComponent } from '@tabler/icons-react';

export const IconCustomJob = createReactComponent(
  'outline',
  'customJob',
  'CustomJob',
  [
    [
      'path',
      {
        key: 'customJob-path-1',
        d: 'M8.33333 17.3143C7.608 17.1498 6.91139 16.8776 6.26666 16.5068M11.6666 2.68579C13.3234 3.06418 14.8027 3.99387 15.8622 5.32263C16.9217 6.65139 17.4987 8.3005 17.4987 9.99996C17.4987 11.6994 16.9217 13.3485 15.8622 14.6773C14.8027 16.006 13.3234 16.9357 11.6666 17.3141M3.81586 14.2442C3.36128 13.5837 3.01602 12.8544 2.79336 12.0842M2.60333 8.75006C2.73667 7.95839 2.99333 7.20839 3.35333 6.52089L3.49417 6.26672M5.756 3.81579C6.53571 3.27904 7.41044 2.89555 8.3335 2.68579',
        strokeWidth: '1.5',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      },
    ],
    [
      'path',
      {
        key: 'customJob-path-2',
        d: 'M12.5 9.99996L9.16663 6.66663V13.3333L12.5 9.99996Z',
        strokeWidth: '1.5',
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
      },
    ],
  ]
);
